import React from 'react'
import clsx from 'clsx'

// The small uppercase line above an H1. The ONLY uppercase text on the site,
// and the only place letter-spacing is allowed.
//
//   <Eyebrow>Mobile car valeting · London · Since 2016</Eyebrow>
//
// Write the text in sentence case: the class uppercases it, so a screen
// reader still hears words rather than initials.
export const Eyebrow = ({ as: Tag = 'p', className, children }) => (
  <Tag className={clsx('gwmc-eyebrow', className)}>{children}</Tag>
)
